import { IFileAttachmentWithURL, TemplateType } from '../extViewmodels';

export enum ImageTemplateStatus {
	Draft = 'Draft',
	Published = 'Published',
	Retired = 'Retired',
}

export enum ImageTemplateProvider {
	Canva = 'Canva',
}

export enum ImageTemplateReviewNoteKind {
	RoleProposalUnavailable = 'RoleProposalUnavailable',
	SkippedElement = 'SkippedElement',
	UnreviewedRoleSuggestions = 'UnreviewedRoleSuggestions',
	DefaultLogoSlot = 'DefaultLogoSlot',
	SlidesWithoutLogoSlot = 'SlidesWithoutLogoSlot',
	LinkedSlideCountChanged = 'LinkedSlideCountChanged',
}

export enum ImageTemplateSlideIssueKind {
	CopyDoesNotFit = 'CopyDoesNotFit',
	TextContrastTooLow = 'TextContrastTooLow',
}

export enum TemplateBrandLogoSource {
	Account = 'Account',
	Placeholder = 'Placeholder',
}

interface IImageTemplateSourceFile extends IFileAttachmentWithURL {
	creationDate?: string;
}

interface IImageTemplateReviewNote {
	kind: ImageTemplateReviewNoteKind;
	message: string;
}

// Image-template routes serialize with System.Text.Json and drop null fields, so anything nullable is optional.
export interface IImageTemplate {
	id: string;
	name?: string;
	status: ImageTemplateStatus;
	version: number;
	slideCount: number;
	reviewNotes?: IImageTemplateReviewNote[];
	fonts?: string[];
	provider?: ImageTemplateProvider;
	sourceUrl?: string;
	sourceKey?: string;
	sourceFile?: IImageTemplateSourceFile;
	systemTemplateId?: string;
	publishedDate?: string;
	creationDate: string;
	lastModifiedDate: string;
}

// The list route returns only what a picker needs; the full model stays behind ManageTemplates.
export interface IImageTemplateSummary {
	id: string;
	name?: string;
	templateType: TemplateType;
	status: ImageTemplateStatus;
	slideCount: number;
	systemTemplateId?: string;
}

export interface IImageTemplateSlideIssue {
	kind: ImageTemplateSlideIssueKind;
	layerId?: string;
	message: string;
}

export interface IImageTemplateSlidePreview {
	slideIndex: number;
	contentType: string;
	imageDataUri: string;
	fitScales?: Record<string, number>;
	issues?: IImageTemplateSlideIssue[];
}

export interface IImageTemplateBrandPreview {
	templateId: string;
	templateVersion: number;
	status: ImageTemplateStatus;
	tokenValues?: Record<string, string>;
	bodyFontFamily?: string;
	headingFontFamily?: string;
	logoSource: TemplateBrandLogoSource;
	slides: IImageTemplateSlidePreview[];
}
